export default V => [
  {
    path: '/courses',
    component: V('products/lists/Base'),
    children: [
      {
        path: '',
        name: 'courses.list',
        component: V('products/lists/Course'),
        meta: {
          title: 'Cursos',
          breadcrumb: [{ title: 'Cursos' }],
        },
        children: [
          {
            name: 'courses.list.filter',
            path: 'filter',
            component: V('products/filters/Course'),
            meta: {
              title: 'Filtrar cursos',
              breadcrumb: [{ title: 'Cursos' }],
            },
          },
        ],
      },
      {
        name: 'courses.create',
        path: 'create',
        component: V('products/forms/create/Course'),
        meta: {
          title: 'Novo curso',
          breadcrumb: [
            { title: 'Cursos', name: 'courses.list' },
            { title: 'Novo curso' },
          ],
        },
      },
      {
        name: 'courses.edit',
        path: 'edit/:id',
        component: V('products/forms/update/Course'),
        meta: {
          title: 'Editar curso',
          breadcrumb: [
            { title: 'Cursos', name: 'courses.list' },
            { title: 'Curso' },
          ],
        },
      },
    ],
  },
]
